import React from 'react'
import { useAuth } from '@/lib/AuthContext'
import { useCommunity } from '@/lib/CommunityContext'
import { sdk } from '@/lib/sdk'

/**
 * Whether "Eventos que organizo" shows in the account menu (F-115): only for someone who organizes at least
 * one event of this community, even without access to the Events space. Any failure hides the link.
 */
export const useOrganizesEvents = () => {
  const { isAuthenticated, isRoleResolved, user } = useAuth()
  const { community } = useCommunity()
  const [show, setShow] = React.useState(false)

  React.useEffect(() => {
    if (!isAuthenticated || !isRoleResolved || !community?.id) { setShow(false); return }
    let alive = true
    sdk.events.organizing(1)
      .then((r) => { if (alive) setShow((r?.totalCount ?? r?.events?.length ?? 0) > 0) })
      .catch(() => { if (alive) setShow(false) })
    return () => { alive = false }
  }, [isAuthenticated, isRoleResolved, community?.id, user?.id])

  return show
}
